import React from 'react';
import {Routes, Route} from 'react-router-dom';
import LayoutFeature from '../layout/layout-feature';
import publicRoutes from '../../routes/public.routes';

function PublicRoutesFeature() {
  const routes = publicRoutes();
  return (
    <Routes>
      <Route path="/" key="home-layout" element={<LayoutFeature />}>
        {routes.map(({slug, path, Component}) => (
          <Route path={path} key={slug} element={<Component />} />
        ))}
      </Route>
    </Routes>
  );
}

export default PublicRoutesFeature;
